<template>
  <div class="cancel-flow-intro">
    <p>
      Shortform helps you learn more in less time. Do you value your personal
      growth at more than $1 per hour? If so, keeping Shortform might be worth
      it.
    </p>
    <div class="cancel-flow-intro__divider" />
    <img
      class="cancel-flow-intro__image"
      src="@/assets.app/images/warren_buffet_exp_cancel_save_flow.png"
      width="360"
      height="254"
      alt=""
    />
    <p>
      We're inspired by Warren Buffett, who said:
      <strong>
        "The best investment you can make is an investment in yourself. The more
        you learn, the more you'll earn."
      </strong>
    </p>
  </div>

  <div class="cancel-flow-popup__footer">
    <AppButton
      :disabled="loading"
      class="cancel-flow-popup__cta"
      @click="onKeep"
    >
      Keep my personal growth
    </AppButton>
    <AppButton
      :danger="true"
      :loading="loading"
      :disabled="loading"
      class="cancel-flow-popup__cta"
      @click="onContinue"
    >
      End my personal growth
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import { Mixpanel } from '@/analytics/mixpanel'

const props = defineProps<{
  billing: BillingView
  loading: boolean
}>()
const emit = defineEmits<{
  (e: 'keep'): void
  (e: 'continue'): void
}>()

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'intro')
})

function onKeep(): void {
  Mixpanel.trackCancelFlowButtonClick(props.billing, 'intro', 'keep')
  emit('keep')
}

function onContinue(): void {
  Mixpanel.trackCancelFlowButtonClick(props.billing, 'intro', 'continue')
  emit('continue')
}
</script>
